import * as api from '../../api/user'
import { moduleFactory } from '../helper'
// import { ConfirmPlugin } from 'vux'
// import regex from '../../common/utils/regex'
import { dataWithPath } from '../../common/utils'

import Vue from 'vue'
// Vue.use(ConfirmPlugin)
const arr = [
  ['register', 'registerInfo', 'data'],
  ['validate', 'validateInfo', 'data'],
  ['oauthToken', 'token', 'data'],
  ['updateOpenId', 'updateOpenIdInfo', 'data'],
  ['checkUser', 'checkUserInfo', 'data'],
  ['jsapiConfig', 'jsapiConfigInfo', 'data']
]

const cached = ['jsapiConfig']
const updateUserInfo = localStorage.getItem('updateUserInfo')
const unitId = sessionStorage.getItem('unitId')
const user = {
  state: {
    info: updateUserInfo && JSON.parse(updateUserInfo) || {
      personName: '',
      mobile: '',
      personCode: '',
      userId: '',
      accessToken: ''
    },
    managerName: '',
    unitId: unitId || ''
  },
  mutations: {
    updateUserInfo: function (state, payload) {
      if (payload.personCode) {
        api.updateOpenId(payload.personCode)
      }
      state.info = { ...state.info, ...payload }
      localStorage.setItem('updateUserInfo', JSON.stringify(state.info))
    },
    updateManagerName: function (state, payload) {
      state.managerName = payload.managerName
    },
    updateUnitId: function (state, payload) {
      state.unitId = payload.unitId
      sessionStorage.setItem('unitId', payload.unitId)
    },
    oauthToken: function (state, payload) {
      let token = dataWithPath(payload, 'data.access_token')
      if (token) {
        state.info = { ...state.info, accessToken: token }
        localStorage.setItem('updateUserInfo', JSON.stringify(state.info))
      }
    }
  },
  actions: {
    inputPersonCode: function (context, params) {
      const { replace } = params || {}
      if (context.state.info.personCode && !replace) {
        return Promise.resolve(context.state.info.personCode)
      } else {
        return new Promise(function (resolve, reject) {
          Vue.$vux.confirm.prompt('证件号码', {
            title: '请输入您报名时提供的证件号码获取试题信息',
            closeOnConfirm: false,
            onConfirm: (msg) => {
              // 不做验证
              if (msg.length >= 4) {
                localStorage.clear()
                context.commit('updateUserInfo', { personCode: msg })
                context.commit('clearPage', {})
                context.commit('clearPaper', {})
                context.commit('clearEnroll', {})
                Vue.$vux.confirm.hide()
                resolve(msg)
              } else {
                context.commit('showToast', { type: 'text', text: '证件号码不应小于4位', loading: true })
              }
            },
            onCancel: () => {
            }
          })
          Vue.nextTick(() => {
            document.getElementsByClassName('vux-prompt-msgbox')[0].focus()
          })
        })
      }
    }
  }
}

export default moduleFactory(arr, api, cached, user.state, user.mutations, user.actions)
